import React, { useEffect, useMemo, useState } from "react";
import TheoPlayer from "components/TheoPlayer/TheoPlayer";
import PlayerSkeleton from "ui/PlayerSkeleton/PlayerSkeleton";
import AdamTextInput from "forms/inputs/AdamTextInput/AdamTextInput";
import { ArrowUp16 } from "@carbon/icons-react";

// Udpate if status change
const areEqual = (prevProps, nextProps) => {
    console.log("areEqual", prevProps, nextProps)
    return prevProps.source === nextProps.source
}

const TestPlayer = React.memo(function TestPlayer(props = {}) {

    const { source } = props

    const [newValue, setNewValue] = useState("")
    const [readyState, setReadyState] = useState()
    const [currentTime, setCurrentTime] = useState()
    const [playerPlaying, setPlayerPlaying] = useState()

    useEffect(() => {
        resetData()
        setNewValue(source)
        props.onInputChange(source)
    }, [source])

    const resetData = () => {
        setReadyState()
        setCurrentTime(0)
        setPlayerPlaying()
    }

    const onTimeUpdate = (e, player) => {
        setCurrentTime(player.currentTime)
    }

    const onPlay = () => {
        setPlayerPlaying(true)
    }

    const onPause = () => {
        setPlayerPlaying(false)
    }

    const onPlayerError = (e, player) => {
        console.error("onPlayerError", e)
    }

    const handleReadyStateChange = (e, player) => {
        setReadyState(player.readyState)

        // if (player.readyState !== 4) {
        //     return false
        // }
        // const selectedEpisode = context.evt?.episodes?.find(item => item.id === context.episodeId)
        // if (status === LIVE && channel.is_fake_live && liveLocked) {
        //     if (selectedEpisode?.live_started_at) {
        //         const diff = moment().diff(utc(selectedEpisode.live_started_at), "seconds")
        //         setFakeLiveDiff(diff)
        //         player.currentTime = diff;
        //     }
        //     setIsFakeLive(true)
        //     liveLocked = false
        // }
    }

    const onInputChange = (e) => {
        setNewValue(e.target.value)
        props.onInputChange(e.target.value)
    }

    const theoPlayer = useMemo(() => {
        return source ? (
            <TheoPlayer
                source={
                    {
                        sources: {
                            src: source
                        }
                    }
                }
                handleReadyStateChange={(e, player) => handleReadyStateChange(e, player)}
                onTimeUpdate={(e, player) => onTimeUpdate(e, player)}
                onPlay={(e, player) => onPlay(e, player)}
                onPause={(e, player) => onPause(e, player)}
                onPlayerError={(e, player) => onPlayerError(e, player)}
            />
        )
            : (
                <PlayerSkeleton loadingText={(
                    <><span>Waiting for a video source, please type video URL in the input text above and click ok 'Update source' </span><ArrowUp16 /></>
                )} />
            )
    }, [source])

    const readyStateDescription = () => {
        switch (readyState) {
            case 1:
                return "The player has no information about the duration of its source."
            case 2:
                return "The player has information about the duration of its source."
            case 3:
                return "The player has its current frame in its buffer."
            case 4:
                return "The player has enough data for the current playback position, as well as for at least a little bit of time into the future (at least two frames of video, for example)."
            case 5:
                return "The player has enough data available, and the download rate is high enough that the media can be played through to the end without interruption."
            default:
                return ""
        }
    }

    const readyStateCode = () => {
        switch (readyState) {
            case 1:
                return "HAVE_NOTHING"
            case 2:
                return "HAVE_METADATA"
            case 3:
                return "HAVE_CURRENT_DATA"
            case 4:
                return "HAVE_FUTURE_DATA"
            case 5:
                return "HAVE_ENOUGH_DATA"
            default:
                return ""
        }
    }

    return (
        <>
            <div>
                <AdamTextInput
                    defaultValue={newValue}
                    onChange={(e) => onInputChange(e)}
                    placeholder="Insert the video source url and click on 'Update source'"
                />
            </div>
            <div style={{ marginTop: "1rem" }}>
                {theoPlayer}
            </div>
            <div style={{ marginTop: "1rem" }}>
                {
                    source ? (
                        <>
                            <div>Ready state: {readyState}{readyStateCode() ? ` (${readyStateCode()})` : ""}</div>
                            <div className="small">{readyStateDescription()}</div>
                            <div>Curretn time: {currentTime}</div>
                            <div>Status: {playerPlaying ? "Playing" : "Paused"}</div>
                        </>
                    ) : (
                        <>
                            No video data available
                        </>
                    )
                }
            </div>
        </>
    )

}, areEqual)
export default TestPlayer;
